// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyA8AVb2_mUoAmOd7qQ1eDvfKymbbRQbF8k",
  authDomain: "www.gatesofmusic.com",
  projectId: "gatesofmusic-5a40e",
  storageBucket: "gatesofmusic-5a40e.appspot.com",
  messagingSenderId: "165235512756",
  appId: "1:165235512756:web:6333b8c79611af82f14ee1",
  measurementId: "G-LGKR9HH3XW"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app); // ✅ Ajouté
